var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("page-loader", {
        attrs: {
          path: _vm.path,
          text: _vm.$t("global.phrases.loadingYourExperience"),
        },
      })
    : _c("login-page", {
        attrs: {
          portal: "client",
          "prefilled-email":
            !_vm.clientDetails.isGhost && _vm.clientDetails.emailFromShare,
          logo: _vm.$options.filters.getLogo(),
          loading: _vm.buttonLoading.loading,
          "loading-status": _vm.buttonLoading.loadingStatus,
        },
        on: { submit: _vm.handleLogin },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }